import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading = new BehaviorSubject(false);
  private activeRequests = 0;

  constructor(private ngZone: NgZone) {}

  setLoading(loading: boolean) {
    this.ngZone.run(() => this.isLoading.next(loading));
  }

  show(): void {
    this.activeRequests += 1;
    this.ngZone.run(() => this.isLoading.next(true));
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    this.ngZone.run(() => this.isLoading.next(this.activeRequests > 0));
  }

  reset(): void {
    this.activeRequests = 0;
    this.ngZone.run(() => this.isLoading.next(false));
  }

  getLoading(): boolean {
    return this.isLoading.value;
  }
}
